import { render } from "./ManageProfile.vue?vue&type=template&id=3ca779bf"
import script from "./ManageProfile.vue?vue&type=script&lang=js"
export * from "./ManageProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__